
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/redirect/[...ops]",
      function () {
        return require("private-next-pages/redirect/[...ops].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/redirect/[...ops]"])
      });
    }
  